export function convertMoney(number: number | string, lang?: any) {
  return `${(number ? Number(number) : 0).toLocaleString('vi-VN')} ${lang?.global?.VND || 'đ'}`;
}
export function convertMoneyVex(number: number | string) {
  return `${(number ? Number(number) : 0).toLocaleString('vi-VN')}đ`;
}

export function convertThousand(number: number | string) {
  return `${(number ? Number(number) : 0).toLocaleString('vi-VN')}`;
}
